import { render, staticRenderFns } from "./PokemonDetail.vue?vue&type=template&id=e0f0cbf4&scoped=true"
import script from "./PokemonDetail.vue?vue&type=script&lang=js"
export * from "./PokemonDetail.vue?vue&type=script&lang=js"
import style0 from "./PokemonDetail.vue?vue&type=style&index=0&id=e0f0cbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f0cbf4",
  null
  
)

export default component.exports